import { ca } from '@cian/analytics';
import { TPhoneOpenAction } from '../../types/analytics';

export function trackPhoneOpen(action: TPhoneOpenAction, projectId: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action,
    label: `/sale/CSP/spec=company/${projectId}`,
    useLastProducts: true,
  });
}
